import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import { LeistungDetailPage } from '../leistung-detail/leistung-detail';
import { HomePage } from '../home/home';
import { ExpenseItemDetailPage } from '../expense-item-detail/expense-item-detail';

import { ToastController } from 'ionic-angular';


/**
 * Generated class for the CalendarLeistungListePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-calendar-leistung-liste',
  templateUrl: 'calendar-leistung-liste.html',
})
export class CalendarLeistungListePage {
    loading: any;
    Leistungen = [];
    calendar: any = {};
    ExpenseItems = [];

    filter: any = {};

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams,
  	private rhynoApi: RhynoApiProvider,
  	public loadingCtrl: LoadingController,
    public toastCtrl: ToastController) {
  	
  	console.log(navParams.data)
    this.filter = {Datum: navParams.data.Datum, 
      Mitarbeiter: navParams.data.Mitarbeiter}; 


  	this.calendar = navParams.data
    console.log('calendar')
  	console.log(this.calendar)
    //this.getData();
  }
  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }

  getData(){
  	this.loading = this.loadingCtrl.create({
		content: 'einen Moment...'
	});
  	this.loading.present();

  	this.rhynoApi.getLeistung(this.filter).subscribe(
		data => {
		if (data.success){
			this.Leistungen = data.data; 
			console.log(data);
		}
    this.loading.dismiss();
	},
		err => {
		console.log(err);
		this.loading.dismiss();

	},
	() => console.log('Leistungen Search Complete')
	);
  

    //**********************************
      // Spesen
      this.rhynoApi.getExpenseItems(this.filter).subscribe(
      data => {
      if (data.success){
        this.ExpenseItems = data.data; 
        console.log(data);
      }
      },
        err => {
        console.log(err);
      },
      () => console.log('Expenses Search Complete')
      );

      //**********************************

      this.rhynoApi.getErfassungscontrolling({Datum:this.calendar.Datum}).subscribe(
      data => {
      if (data.success){
        this.calendar = data.data[0]; 
        console.log(this.calendar)
          this.calendar.day = new Date(this.calendar.Datum).getDay();
          if (this.calendar.MengeExtern){
            this.calendar.progress = 100/24*this.calendar.MengeExtern;
          } else {
            this.calendar.progress = 0;
            this.calendar.MengeExtern = 0;
          }
          if (this.calendar.day>=1 && this.calendar.day<=5){
            if (this.calendar.MengeExtern==0){
              this.calendar.status = 'ERROR' 
            } else {
              if (this.calendar.MengeExtern>=8){
                this.calendar.status = 'OKFULL' 
              } else {
                this.calendar.status = 'OK' 
              }
            }
          } else {
            if (this.calendar.MengeExtern==0){
              if (this.calendar.MengeExtern>=8){
                this.calendar.status = 'OKFULL' 
              } else {
                this.calendar.status = 'OKWEEKEND'
              }
              
            } else {
              if (this.calendar.MengeExtern>=8){
                this.calendar.status = 'OKFULL' 
              } else {
                this.calendar.status = 'OKFULL'
              }
            }
          }
        
      }else{
        this.presentToast(data.message);
      }
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Inbox Search Complete')
    );
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad CalendarLeistungListePage');
  }
  ionViewWillEnter(){
    this.getData();
  }

  closeModal() {
        this.navCtrl.pop();
    }

    openPageMitarbeiterProject(item){
    this.navCtrl.push(LeistungDetailPage, item);
  }



  new(){
    let data = {
      presettings: {
        Datum: this.filter.Datum
      }
    };
        this.navCtrl.push(HomePage, data);

  }

  createExpenseLunch() {
      let expenseItem = {
      Artikelnummer: 'S100100',
      Bezeichnung: 'Mittagessen',
      Datum: this.calendar.Datum,
      Einzelpreis: 25,
      Netto: 25,
      Menge: 1,
      SteuerCode: '0',
      Steuerprozent: 0
    };

    this.rhynoApi.createExpenseItem(expenseItem).subscribe(data => {
      console.log(data)
      var respData = JSON.parse(data['_body']);
       if (respData['success']){
          this.presentToast('Spesenbeleg gespeichert');

          this.getData();
      }else{
        this.presentToast(respData['message']);
      }

      
    });


  }
createExpenseCar() {
    
  }
createExpenseTrain() {
    
  }

  selectExpenseItem(data){
    this.navCtrl.push(ExpenseItemDetailPage, {create:true, data: data});
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: false
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/calendar-leistung-liste/calendar-leistung-liste.ts